import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-67f6f83b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "buy-more-options-wrap" }
const _hoisted_2 = { class: "tips-box" }
const _hoisted_3 = { class: "tips-header" }
const _hoisted_4 = { class: "tips-content" }
const _hoisted_5 = { class: "cm-ui-mt5" }
const _hoisted_6 = { class: "cm-ui-mb5" }
const _hoisted_7 = { class: "cm-light-text" }
const _hoisted_8 = { class: "cm-light-text" }
const _hoisted_9 = { class: "service-page-title" }
const _hoisted_10 = {
  key: 0,
  class: "selection-bar"
}
const _hoisted_11 = { class: "service-price-wrap" }
const _hoisted_12 = { class: "current-price" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, "￥", -1))
const _hoisted_14 = {
  key: 0,
  class: "origin-price"
}
const _hoisted_15 = { class: "unit" }
const _hoisted_16 = { class: "service-price-wrap" }
const _hoisted_17 = { class: "current-price" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, "￥", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BlueTipsIcon = _resolveComponent("BlueTipsIcon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_ServiceEnum = _resolveComponent("ServiceEnum")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_CmSvgIcon, {
          name: "views/dashboard/service/buy-more/_components/_images/tips",
          monochrome: ""
        }),
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('buyMore.overLimitTipsTitle')), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('buyMore.overLimitTipsP1')), 1),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('buyMore.overLimitTipsP2Lead')), 1),
        _createElementVNode("div", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('buyMore.overLimitLine1Before')), 1),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('buyMore.overLimitLine1Highlight')), 1),
          _createTextVNode(_toDisplayString(_ctx.$t('buyMore.overLimitLine1After')), 1)
        ]),
        _createElementVNode("div", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('buyMore.overLimitLine2Before')), 1),
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('buyMore.overLimitLine2Highlight')), 1),
          _createTextVNode(_toDisplayString(_ctx.$t('buyMore.overLimitLine2After')), 1)
        ]),
        _createElementVNode("div", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('buyMore.overLimitLine3Before')), 1),
          _createVNode(_component_router_link, {
            to: "/dashboard/my-subscribe",
            class: "cm-link-light underline"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('buyMore.overLimitLine3Link')), 1)
            ]),
            _: 1
          }),
          _createTextVNode(_toDisplayString(_ctx.$t('buyMore.overLimitLine3After')), 1)
        ]),
        _createElementVNode("div", null, [
          (!_ctx.isPrivateLike)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_ctx.$t('buyMore.overLimitLine4Public')), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(_ctx.$t('buyMore.overLimitLine4Private')), 1)
              ], 64))
        ])
      ])
    ]),
    _createElementVNode("h3", _hoisted_9, _toDisplayString(_ctx.$t('buyMore.exceedServiceDetailTitle')), 1),
    (!_ctx.isPrivateLike)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(_component_BlueTipsIcon, { class: "cm-ui-ml15 cm-ui-mr10" }),
          _createVNode(_component_el_button, {
            type: "text",
            disabled: !_ctx.selectedCount,
            onClick: _ctx.handleCancelSelect
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('subscribeDetails.renewal.cancelSelect')), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createVNode(_component_el_button, {
            type: "text",
            disabled: !_ctx.selectedCount,
            onClick: _ctx.toggleShowSelected
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.isShowSelection ? _ctx.$t('subscribeDetails.renewal.closeSelectedWithCount', { n: _ctx.selectedCount }) : _ctx.$t('subscribeDetails.renewal.viewSelectedWithCount', { n: _ctx.selectedCount })), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_table, {
      "empty-text": _ctx.$t('common.noData'),
      class: "table-wrap",
      ref: "tableNode",
      data: _ctx.tableData,
      width: "100%",
      height: "100%",
      "row-key": "price_id",
      onSelectionChange: _ctx.handleSelectionChange
    }, {
      default: _withCtx(() => [
        (!_ctx.isPrivateLike)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              type: "selection",
              "reserve-selection": "",
              width: "50",
              fixed: ""
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          label: _ctx.$t('subscribeDetails.renewal.colServiceName'),
          "min-width": "200"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_ServiceEnum, {
              services: [_ctx.serviceDisplayName(scope.row)]
            }, null, 8, ["services"])
          ]),
          _: 1
        }, 8, ["label"]),
        (!_ctx.isPrivateLike)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 1,
              label: _ctx.$t('buyMore.colDiscountPrice'),
              "min-width": "150"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("span", _hoisted_12, [
                    _hoisted_13,
                    _createTextVNode(_toDisplayString(scope.row.unit_price / 100), 1)
                  ]),
                  (scope.row.unit_price !== scope.row.origin_unit_price)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, "￥" + _toDisplayString(scope.row.origin_unit_price / 100), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('buyMore.unitPerTerminalPerYear')), 1)
                ])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          label: _ctx.$t('subscribeDetails.renewal.colOrigDuration'),
          "min-width": "100"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.cycle_count) + _toDisplayString(_ctx.DateKindLabel[scope.row.date_kind]), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          label: _ctx.$t('subscribeDetails.renewal.colOrigCount'),
          "min-width": "100"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.terminal_count) + _toDisplayString(_ctx.$t('buyMore.terminalUnitSuffix')), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          label: _ctx.$t('buyMore.colExceedNeedPurchase'),
          "min-width": "150"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.exceed_count) + _toDisplayString(_ctx.$t('buyMore.terminalUnitSuffix')), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          label: _ctx.$t('buyMore.colRemainingUsable'),
          "min-width": "200"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(_ctx.$t('buyMore.daysUntilDate', { days: scope.row.expires_days, date: _ctx.formatTimeStamp(scope.row.expires_time, 'YYYY-MM-DD') })), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          label: _ctx.$t('buyMore.colNeedPurchaseDuration'),
          "min-width": "200"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(_ctx.$t('buyMore.daysUntilDate', { days: scope.row.increase_days, date: _ctx.formatTimeStamp(scope.row.increase_time, 'YYYY-MM-DD') })), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        (!_ctx.isPrivateLike)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 2,
              "min-width": "100",
              fixed: "right"
            }, {
              header: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('buyMore.amount')) + " ", 1),
                _createVNode(_component_el_tooltip, {
                  placement: "top",
                  effect: "light"
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", null, _toDisplayString(_ctx.$t('buyMore.priceCalcTitle')), 1),
                    _createElementVNode("div", null, _toDisplayString(_ctx.$t('buyMore.priceCalcFormula')), 1),
                    _createElementVNode("div", null, _toDisplayString(_ctx.$t('buyMore.priceCalcNote366')), 1)
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("i", null, [
                      _createVNode(_component_CmSvgIcon, {
                        name: "assets/icons/warn-border-gray",
                        size: 18,
                        monochrome: ""
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx((scope) => [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("span", _hoisted_17, [
                    _hoisted_18,
                    _createTextVNode(_toDisplayString(scope.row.amount / 100), 1)
                  ])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["empty-text", "data", "onSelectionChange"])
  ]))
}